import { Fade } from "react-awesome-reveal";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";

const NavigationItem = (props) => {
    return (
        <NavLink
            exact
            to={props.link}
            className="hover:text-main px-5"
            activeClassName="text-main font-medium pb-3 sm:border-b-2 sm:border-main sm:border-solid"
            onClick={() => props.dropDownHandler(false)}
        >
            {props.children}
        </NavLink>
    );
};

const NavigationItems = (props) => {
    return (
        <div className="text-content-color font-manrope font-normal text-sm flex flex-col text-center md:flex-row">
            <Fade
                direction="down"
                cascade
                className="my-3"
                triggerOnce={props.calledBy === "dropdown" ? false : true}
            >
                <NavigationItem
                    link="/"
                    dropDownHandler={props.dropDownHandler}
                >
                    Home
                </NavigationItem>
                <NavigationItem
                    link="/projects"
                    dropDownHandler={props.dropDownHandler}
                >
                    Projects
                </NavigationItem>
                <a
                    onClick={() => props.dropDownHandler(false)}
                    className="hover:text-main px-5"
                    href="https://dhyeythumar.medium.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Blog
                </a>
                <a
                    onClick={() => props.dropDownHandler(false)}
                    className="text-main px-5 py-2 box-border-md my-auto md:ml-5"
                    href={props.resumeUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Resume
                </a>
            </Fade>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        resumeUrl: state.common.resumeUrl,
    };
};

export default connect(mapStateToProps, null)(NavigationItems);
